import React, { useMemo } from 'react';
import { Checkbox } from '@/components/checkbox';
import { ListItem, ListOption } from '@/components/list-item';
import { StyleSheet, Text, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface Props<T> {
  item: ListOption;
  onChange: (value: T[]) => void;
  options: ListOption[];
  selectedValues: T[];
}

export const CheckboxListItem = <T extends string>({
  item,
  onChange,
  options,
  selectedValues,
}: Props<T>) => {
  const selectedValuesSet = useMemo(() => {
    return new Set(selectedValues);
  }, [selectedValues]);

  return (
    <ListItem
      item={item}
      renderMainContent={() => {
        return (
          <View style={styles.content}>
            <Text style={TYPOGRAPHY.listTitle}>{item.title}</Text>
            <View style={styles.checkboxList}>
              {options.map((option) => {
                const optionValue = option.value as T;
                return (
                  <Checkbox
                    isSelected={selectedValuesSet.has(optionValue)}
                    key={option.value}
                    label={option.title}
                    onSelect={() => {
                      if (selectedValuesSet.has(optionValue)) {
                        onChange(
                          selectedValues.filter((v) => v !== optionValue),
                        );
                      } else {
                        onChange([...selectedValues, optionValue]);
                      }
                    }}
                    style={styles.checkbox}
                    trackingData={null}
                  />
                );
              })}
            </View>
          </View>
        );
      }}
    />
  );
};

const styles = StyleSheet.create({
  checkbox: {
    paddingHorizontal: 0,
    paddingVertical: 8,
  },
  checkboxList: {
    marginTop: 8,
  },
  content: {
    flex: 1,
  },
});
